<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth' // get token from cookie
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'avatar',
      'name',
      'token'
    ])
  },
  async created() {
    if (getToken()) {
      await this.$store.dispatch('user/getInfo')
    }
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue